<template>
	<div class="d-flex flex-wrap align-items-center justify-content-start smart-mode">
		<div
			class="d-flex align-items-center justify-content-start"
			:class="{
				'pr-1': isSizeSmall && !noPaddingRight,
				'pr-2': !isSizeSmall && !noPaddingRight,
				'pr-0': noPaddingRight,
			}">
			<label class="smart-toggle" :class="{ 'toggle-sm':  isSizeSmall }">
				<input type="checkbox" class="toggle" :disabled="disabled" :checked="value" @change="onChange">
				<span class="slider"></span>
				<span class="labels" :class="{ 'label-sm': isSizeSmall }" data-on="ON" data-off="OFF"></span>
			</label>
		</div>
		<span class="input-checkbox-text">{{ label }}</span>
		<i class="material-icons info has-tooltip" v-tooltip="info" v-if="hasInfo">
			info
		</i>
	</div>
</template>

<script>
export default {
	name: 'CheckboxToggle',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '',
		},
		info: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: 'medium', // small, medium
		},
		noPaddingRight: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onChange(event) {
			const isChecked = event.target.checked;
			this.$emit('input', isChecked);
		},
	},
	computed: {
		hasInfo() {
			return this.info && this.info !== '';
		},
		isSizeSmall() {
			const isSmall = this.size === 'small';

			return isSmall;
		},
	},
};
</script>

<style scoped>
.toggle-sm {
	--width: 3rem !important;
	--height: 1rem !important;
}

.label-sm {
	top: 1px !important;
}
</style>
